/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { useTranslation } from '@web/src/lib/intl/react'
import { useMemo } from 'react'
import type { EventCategoryEnum } from 'types/graphql'

const EVENT_CATEGORY_ORDER: readonly EventCategoryEnum[] = [
  'KINK',
  'CAMPING',
  'CLUBS',
  'HOUSE_PARTIES',
  'SOCIAL_AND_MEET',
  'TAKEOVER',
  'CRUISES',
  'VACATION',
  'OTHER',
] as const

/** i18n keys (English phrases as keys per project convention). */
const EVENT_CATEGORY_MESSAGE_KEYS: Record<EventCategoryEnum, string> = {
  KINK: 'Kink',
  CAMPING: 'Camping',
  CLUBS: 'Clubs',
  HOUSE_PARTIES: 'House Parties',
  SOCIAL_AND_MEET: 'Social & Meet',
  TAKEOVER: 'Takeover',
  CRUISES: 'Cruises',
  VACATION: 'Vacations',
  OTHER: 'Other',
}

export function useEventCategoryOptions() {
  const { t } = useTranslation()

  return useMemo(
    () => ({
      selectOptions: EVENT_CATEGORY_ORDER.map((value) => ({
        value,
        label: t(EVENT_CATEGORY_MESSAGE_KEYS[value]),
      })),
      labelFor: (category: EventCategoryEnum) => t(EVENT_CATEGORY_MESSAGE_KEYS[category]),
    }),
    [t]
  )
}
